<ng-container *ngIf="vista === 'card'">
  <div class="ds-card">
    <div class="ds-card__cabecera">
      <span class="ds-card__titulo">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_ADJUNTOS' | translate }}</span>
    </div>
    <div class="grid align-items-end">
      <div class="col-2">
        <app-boton-icono icono="assets/icons/icono-mas.svg" (click)="abrirModalAgregarAdjunto()">
          {{ 'BTN_AGREGAR' | translate }}
        </app-boton-icono>
      </div>
      <div class="col-10 ds-buscador">
        <span class="p-input-icon-left">
          <img src="assets/icons/ico-buscar-lupa.svg" alt="">
          <input type="text" pInputText placeholder="{{ 'LBL_BUSCAR' | translate }}" [(ngModel)]="filtroAdjuntos">
        </span>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="tablaTpl; context: { tableClass: 'ds-tabla' }"></ng-container>
  </div>
</ng-container>

<ng-container *ngIf="vista === 'arbol'">
  <div class="arbol-seccion-bloque">
    <div class="arbol-seccion-header">
      <div class="arbol-seccion-izq">
        <span class="arbol-seccion-titulo">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_ADJUNTOS' | translate }}</span>
        <button type="button" class="btn-agregar-outline" (click)="abrirModalAgregarAdjunto()">
          <i class="fa fa-plus"></i>
          <span>{{ 'BTN_AGREGAR' | translate }}</span>
        </button>
      </div>
      <div class="arbol-seccion-der">
        <span class="p-input-icon-left buscador-seccion">
          <i class="fa fa-search"></i>
          <input type="text" pInputText placeholder="{{ 'LBL_BUSCAR' | translate }}" [(ngModel)]="filtroAdjuntos">
        </span>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="tablaTpl; context: { tableClass: 'ds-tabla tabla-adjuntos-arbol' }"></ng-container>
  </div>
</ng-container>

<ng-template #tablaTpl let-tableClass="tableClass">
  <p-table [value]="adjuntosFiltrados" [loading]="cargandoAdjuntos" [paginator]="true" [rows]="rows"
           [alwaysShowPaginator]="true" [styleClass]="tableClass">
    <ng-template pTemplate="header">
      <tr>
        <th class="text-left">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_DOCUMENTO' | translate }}</th>
        <th class="text-center">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_ESTADO' | translate }}</th>
        <th class="text-center">{{ 'LBL_ACCIONES' | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-adj>
      <tr>
        <td class="text-left">{{ adj.nombre }}</td>
        <td class="text-center">
          <span class="admsb-chip-estado" [ngClass]="claseEstadoAdjunto(adj)">
            {{ estadoAdjunto(adj) }}
          </span>
        </td>
        <td class="text-center">
          <div class="admsb-acciones-adjunto" [hidden]="estaCargando(adj)">
            <div class="file-false">
              <p-fileUpload name="file" url="{{ adj.indicadorTercero ? svcThUrlTercero : svcThUrl }}" [auto]="false"
                            class="upload-avatar" mode="basic" fSize [codigoAdjunto]="adj.codigo"
                            (onBeforeUpload)="onBeforeSendAdjunto($event)"
                            (onValidSelect)="onSelectAdjunto($event.files, adj)"
                            (onUpload)="onUploadAdjunto($event, adj)">
              </p-fileUpload>
              <button type="button" pButton class="btn-action-premium admsb-btn-icono-adjuntar"
                      title="{{ 'BTN_EDITAR' | translate }}">
                <span class="admsb-icono-adjuntar"></span>
              </button>
            </div>
            <button type="button" pButton class="btn-action-premium" icon="fa fa-eye"
                    title="{{ 'BTN_VISUALIZAR' | translate }}"
                    (click)="verAdjunto(adj)" [disabled]="!adj.idAdjunto">
            </button>
            <button type="button" pButton class="btn-action-premium" icon="fa fa-trash-o"
                    title="{{ 'BTN_ELIMINAR' | translate }}"
                    (click)="eliminarAdjunto(adj)">
            </button>
          </div>
          <div [hidden]="!estaCargando(adj)">
            <i class="fa fa-refresh fa-spin fa-fw"></i>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="3" class="text-center msg-vacio">{{ 'MSG_NOHAYREGISTROS' | translate }}</td>
      </tr>
    </ng-template>
  </p-table>
</ng-template>


<app-p-dialog-adjunto-visor *ngIf="showModalAdjunto" [showModalAdjunto]="showModalAdjunto"
                            header="ARCHIVO ADJUNTO"
                            [loadingFile]="loadingFile"
                            [fileUrl]="fileUrl" [subAdjunto]="subAdjunto" [detalle]="false"
                            [svcThUrl]="adjuntoVisor?.indicadorTercero ? svcThUrlTercero : svcThUrl"
                            (cerrarModalAdjuntoEmit)="cerrarModalAdjunto()"
                            (descargarArchivoEmit)="descargarArchivo()"
                            (onBeforeSendEmit)="onBeforeSendAdjunto($event)"
                            (onSelectEmit)="onSelectAdjunto($event.files, adjuntoVisor)"
                            (onUploadEmit)="onUploadAdjunto($event, adjuntoVisor)">
</app-p-dialog-adjunto-visor>

<p-confirmDialog #cdAdj [key]="confirmKey" styleClass="ds-confirm">
  <ng-template pTemplate="footer">
    <app-boton-icono iconoFa="fa fa-close" variante="outline"
                     (click)="cdAdj.reject()">{{ 'LBL_NO' | translate }}
    </app-boton-icono>
    <app-boton-icono iconoFa="fa fa-check" variante="full"
                     (click)="cdAdj.accept()">{{ 'LBL_SI' | translate }}
    </app-boton-icono>
  </ng-template>
</p-confirmDialog>
